import type { PMTranslations } from "../../types/pm";

export const pm: PMTranslations = {
  sidebar: {
    sectionLabel: "Projektijuhtimine",
    issues: "Ülesanded",
    myIssues: "Minu ülesanded",
    notifications: "Teavitused",
  },
  myIssues: {
    title: "Minu ülesanded",
    subtitle: "Sulle määratud, sinu loodud või sind mainivad ülesanded",
    tabs: { assigned: "Vastutaja", created: "Loodud", mentions: "Mainimised" },
    empty: {
      assigned: {
        title: "Sulle pole ülesandeid määratud",
        subtitle: "Siia ilmuvad ülesanded, kus oled vastutaja.",
      },
      created: {
        title: "Sa pole ühtegi ülesannet loonud",
        subtitle: "Siia ilmuvad sinu loodud ülesanded.",
      },
      mentions: {
        title: "Mainimisi veel pole",
        subtitle: "Siia ilmuvad ülesanded, kus sind on kommentaaris mainitud.",
      },
      overdue: {
        title: "Tähtaja ületanud ülesandeid pole",
        subtitle: "Siia ilmuvad sulle määratud ülesanded, mille tähtaeg on möödas.",
      },
      filteredHint: "Tühjenda filtrid või projektivalik, et neid näha.",
    },
  },
  issues: {
    title: "Ülesanded",
    subtitle: "Projekti ülesannete jälgimine ja haldamine",
    newIssue: "Uus ülesanne",
    linkingLabel: "Seotud:",
    deepLinkFailed:
      "Ülesannet ei õnnestunud avada. See võib olla kustutatud või sul pole sellele ligipääsu.",
    deepLinkUnavailable:
      "Ülesannet ei õnnestunud praegu laadida. Ava kasutatud link uuesti või leia ülesanne loendist.",
    saveWithSection: "Salvesta koos lõikega",
    saveWithSectionHint: "Ülesande uuesti avamisel taastatakse praegune lõige ja vaade.",
    viewpointSaveFailed: "Ülesanne loodi, kuid salvestatud vaadet ei õnnestunud talletada.",
    protocol: {
      button: "Loo protokoll",
      title: "Loo protokoll",
      description: "Vali ajavahemik, seejärel ülesanded ja see, mida dokument sisaldab.",
      step: "Samm {current}/{total}",
      datesStep: "Protokolli ajavahemik",
      today: "Täna",
      thisWeek: "Sel nädalal",
      thisMonth: "Sel kuul",
      customRange: "Kohandatud ajavahemik",
      customRangeHint: "Vali algus- ja lõppkuupäev.",
      selectedRange: "Valitud ajavahemik: {range}",
      issuesStep: "Ülesanded",
      issuesStepHint: "Eemalda linnuke ülesannetelt, mida protokolli ei lisata.",
      selectAll: "Vali kõik ({count})",
      selectedCount: "Valitud {count}/{total}",
      issuesLoading: "Ülesannete laadimine…",
      issuesError: "Selle ajavahemiku ülesandeid ei õnnestunud laadida.",
      retry: "Proovi uuesti",
      noIssuesTitle: "Selles ajavahemikus ülesandeid pole",
      noIssuesDescription:
        "Nende kuupäevade vahel ei muutunud midagi. Mine tagasi ja vali teine ajavahemik või jätka tühja protokolli loomiseks.",
      includeIssueAria: "Lisa ülesanne #{number}: {title}",
      openIssueAria: "Ava ülesanne #{number}: {title}",
      issueDetailTitle: "Ülesande üksikasjad",
      pdfLanguage: "PDF-i keel",
      pdfLanguageEt: "Eesti keel",
      pdfLanguageEn: "Inglise keel",
      save: {
        created: "Sinu protokoll on valmis",
        createdDetail: "{filename} on alla laaditud. Kas salvestada see ka projekti?",
        saveToProject: "Salvesta projekti",
        uploading: "Projekti salvestamine…",
        saved: "Protokoll salvestatud",
        savedInProject: "Salvestatud projekti {project}.",
        savedInFolder: "Salvestatud: {project} · {folder}.",
        unconfirmed: "Protokolli salvestamist ei saanud kinnitada",
        unconfirmedDetail:
          "Protokoll võib olla juba projektis. Enne uut salvestamist kontrolli projekti faile.",
        failed: "Protokolli ei õnnestunud projekti salvestada.",
        dismiss: "Peida",
        unavailable: "Projekti salvestamiseks logi sisse organisatsiooni.",
        destinationTitle: "Kuhu protokoll salvestada?",
        destinationDescription:
          "Vali projekt ja kaust, kuhu protokoll salvestada. Fail jääb igal juhul ka sinu seadmesse.",
        destinationSubmit: "Salvesta siia",
      },
      contentStep: "Dokumendi sisu",
      contentStepHint:
        "Märgi, mida protokoll sisaldab. Ajavahemik, hoone ja hoiatused kuvatakse alati.",
      sections: {
        summary: {
          name: "Ülesannete kokkuvõte",
          help: "Mitu ajavahemiku ülesannet on töös, lahendatud ja suletud.",
        },
        issues: {
          name: "Ülesannete tabel",
          help: "Iga ülesande kohta rida: staatus, vastutajad, distsipliinid ja tähtaeg.",
        },
        activity: {
          name: "Tegevuste logi",
          help: "Ajavahemikus iga ülesandega tehtud kuupäevastatud muudatused.",
        },
      },
      columnsHint: "Vali, mida iga rida sisaldab.",
      columns: {
        status: "Staatus",
        assignees: "Vastutajad",
        disciplines: "Distsipliinid",
        startDate: "Alguskuupäev",
        dueDate: "Tähtaeg",
        commentCount: "Kommentaarid",
      },
      columnsCommentsHelp: "Lisab tabelisse kommentaaride arvu ja trükib kommentaarid tabeli alla.",
      commentsLoading: "Kommentaaride laadimine…",
      commentsError: "Kommentaare ei õnnestunud laadida, seetõttu on eksport ootel.",
      filters: "Filtrid",
      filterStatus: "Staatus",
      filterDiscipline: "Distsipliin",
      filterClear: "Tühista filtrid",
      filteredCount: "{count}/{total} selles ajavahemikus",
      noMatches: "Ükski ülesanne ei vasta neile filtritele.",
      sortAscending: "Sorteeritud kasvavalt",
      sortDescending: "Sorteeritud kahanevalt",
      documentDate: {
        label: "Kuupäev",
        hint: "Trükitakse protokolli paremasse ülanurka. Tühjenda, kui kuupäeva pole vaja.",
        placeholder: "Vali kuupäev",
        time: "Kellaaeg",
        hours: "Tund",
        minutes: "Min",
        clear: "Tühjenda",
      },
      notesHeading: "Sinu enda lõigud",
      notesHint:
        "Kuvatakse pärast kokkuvõtet ja enne ülesannete tabelit, sinu määratud järjekorras.",
      addNote: "Lisa lõik",
      noteHeadingLabel: "Lõigu pealkiri",
      noteHeadingPlaceholder: "Vastuvõetud otsused",
      noteBodyLabel: "Lõigu tekst",
      noteBodyPlaceholder: "Milles lepiti kokku, kes teeb ja mis ajaks.",
      removeNote: "Eemalda lõik",
      noteIncomplete: "Anna igale lõigule nii pealkiri kui ka tekst või eemalda see.",
      nothingSelected: "Märgi vähemalt üks osa või kirjuta ise üks lõik.",
      issueCountOne: "1 ülesanne selles ajavahemikus",
      issueCountMany: "{count} ülesannet selles ajavahemikus",
      issueCountAtLeast: "Vähemalt {count} ülesannet selles ajavahemikus",
      issueCountLoading: "Loendan…",
      preview: "Eelvaade",
      previewTitle: "Protokolli eelvaade",
      previewing: "Eelvaate valmistamine…",
      previewError: "Eelvaadet ei õnnestunud luua. Proovi uuesti.",
      continue: "Jätka",
      back: "Tagasi",
      export: "Ekspordi",
      exporting: "PDF-i loomine…",
      exportSuccess: "Protokoll salvestati failina {filename}",
      exportError: "Protokolli loomine ebaõnnestus. Proovi uuesti.",
      attachments: {
        heading: "Manused",
        hint: "Prinditakse lisasse, igaüks oma nimega: pildid piltidena, PDF-id lehekülg lehekülje haaval. Teised failid ainult nimega.",
        attach: "Lisa",
        remove: "Eemalda protokollist",
        issueOption: "Manused",
        issueOptionHelp: "Igale ülesandele lisatud failid.",
        inTable: "Tabelis",
        inAppendix: "Lisas",
        issuesFound: "Valitud ülesannete faile: {count}",
        issuesLoading: "Laadin ülesannete manuseid…",
        issuesError: "Ülesannete manuseid ei õnnestunud laadida, seetõttu on eksport ootel.",
        issuesNone: "Valitud ülesannetel ei ole manuseid.",
        preparing: "Manuste ettevalmistamine…",
        notIncluded:
          "Manuseid, mida ei õnnestunud lisada: {count}. Protokollis on need sellisena märgitud.",
        embedOriginals: "Lisa originaalfailid",
        embedOriginalsHelp:
          "Iga siin lisatud fail on PDF-i sees täiskvaliteedis ja avaneb kirjaklambri ikoonilt. PDF muutub suuremaks; kuni 50 MB faile.",
        originalsLeftOut:
          "PDF-i lisamata originaalfailid: {count}. Need on siiski prinditud või nimega loetletud.",
        lookupError: "Valitud dokumente ei õnnestunud lisada. Proovi uuesti.",
      },
      design: {
        button: "Kujundus",
        title: "Protokolli kujundus",
        description: "Muudab protokolli välimust. Sisu jääb samaks.",
        layouts: {
          classic: {
            name: "Klassikaline",
            description: "Franklini päis, varjutatud andmepaneel ja ääristatud tabeliread.",
          },
          modern: {
            name: "Kaasaegne",
            description: "Julge värviriba lehe ülaosas, kokkuvõttekaardid ja triibuline tabel.",
          },
          compact: {
            name: "Kompaktne",
            description:
              "Väiksem kiri ja vähem kujunduselemente, et pikk nimekiri võtaks vähem lehekülgi.",
          },
        },
      },
      document: {
        title: "Protokoll",
        period: "Ajavahemik",
        building: "Hoone",
        project: "Projekt",
        allProjects: "Kõik projektid",
        unknown: "Teadmata",
        contents: "Sisu",
        selection: "Valik",
        selectionPartial: "{selected} ülesannet {total}-st sellel ajavahemikul",
        generated: "Loodud",
        summary: "Ülesannete kokkuvõte",
        inProgress: "Töös",
        resolved: "Lahendatud",
        closed: "Suletud",
        issue: "Ülesanne",
        status: "Staatus",
        assignees: "Vastutajad",
        disciplines: "Distsipliinid",
        startDate: "Alguskuupäev",
        dueDate: "Tähtaeg",
        issues: "Ülesanded",
        notes: "Märkused",
        activity: "Tegevused",
        noActivity: "Sellel ajavahemikul ei salvestatud ülesannetega seotud tegevusi.",
        commentCount: "Kommentaare",
        comments: "Kommentaarid",
        noComments: "Sellel ajavahemikul kommentaare ei salvestatud.",
        commentEmpty: "(ainult manus)",
        commentsTruncated:
          "Sellel ajavahemikul on rohkem kommentaare, kui üks eksport mahutab. Loetletud on ainult osa neist.",
        truncated:
          "Sellel ajavahemikul on rohkem tegevusi, kui üks eksport mahutab. Loetletud on ainult uusimad muudatused ja nendega seotud ülesanded.",
        omitted:
          "Osa selle ajavahemiku muudatusi kuulub ülesannetele, mida ei õnnestunud lugeda, ja neid ei ole siin loetletud.",
        page: "Lehekülg {current}/{total}",
        attachments: "Manused",
        attachmentsAdded: "Protokollile lisatud",
        attachmentShownAbove: "Näidatud eespool",
        attachmentsWithoutPreview: "Eelvaateta failid",
        attachmentUnsupported: "Vormingut ei saa printida",
        attachmentFailed: "Ei õnnestunud lisada",
        attachmentCaption: "Manus {number} · {filename}",
      },
    },
    startAfterDue: "Alguskuupäev on hilisem kui tähtaeg",
    loadingMore: "Laadin ülejäänud ülesandeid…",
    loadCeiling:
      "Kuvatakse esimesed {count} ülesannet. Ülejäänuteni jõudmiseks kasuta otsingut või filtreid.",
    listView: "Nimekiri",
    kanbanView: "Kanban",
    ganttView: "Gantt",
    gantt: {
      day: "Päev",
      week: "Nädal",
      month: "Kuu",
      resizeColumn: "Muuda pealkirjaveeru laiust",
      unscheduled: "Ajastamata",
      oneUnsavedChange: "1 salvestamata muudatus",
      unsavedChanges: "{count} salvestamata muudatust",
      confirmChanges: "Kinnita",
      discardChanges: "Loobu",
      leaveTitle: "Lahkuda salvestamata?",
      leaveBody: "Siin tehtud ajakava muudatused on salvestamata. Lahkumisel need kaovad.",
      leaveStay: "Jää siia",
      leaveDiscard: "Loobu muudatustest",
      addIssueHere: "Lisa siia ülesanne",
      linkHint: "Lohista teisele ülesandele · Esc tühistab",
      linkRefusedDuplicate: "Need ülesanded on juba seotud",
      linkRefusedCrossProject: "Siduda saab ainult sama projekti ülesandeid",
      linkRefusedCycle: "See seos tekitaks ringi",
      linkRefusedUnavailable: "See ülesanne pole enam saadaval",
      saveSnapshot: "Salvesta ajakava",
      snapshotHistory: "Ajakavade ajalugu",
      snapshotSaveTitle: "Salvesta projekti ajakava",
      snapshotLabel: "Nimi",
      snapshotLabelPlaceholder: "Baasajakava",
      snapshotSaveAction: "Salvesta ajakava",
      snapshotBlockedByChanges:
        "Kinnita või loobu muudatustest — salvestatakse ainult kinnitatud ajakava.",
      snapshotEmpty: "Ajakavasid pole veel salvestatud.",
      snapshotRename: "Nimeta ümber",
      snapshotRenameUnavailable: "Ajakavasid ei saa veel ümber nimetada. Proovi hiljem uuesti.",
      snapshotDeleteRefused:
        "Seda ajakava ei saanud kustutada. See võib olla juba kustutatud või sul ei pruugi olla selleks õigust.",
      snapshotViewing: "Vaatad salvestatud ajakava",
      snapshotExit: "Tagasi praeguse ajakava juurde",
      snapshotCompare: "Võrdle tänasega",
      compareTitle: "Salvestatud ajakava võrrelduna tänasega",
      compareSnapshotSide: "Ajakava · {label}",
      compareTodaySide: "Täna",
      compareMoved: "Liikunud",
      compareAdded: "Hiljem lisatud",
      compareGone: "Vahepeal kadunud",
      compareUnchanged: "Muutumatu",
      compareShowing: "Kuvatud {shown} / {total}",
      compareShowUnchanged: "Näita muutumatuid",
      compareNoRows: "Praeguse filtriga pole midagi näidata.",
      compareNothingChanged: "Pärast seda ajakava pole midagi liikunud.",
      compareTabTimeline: "Ajatelg",
      compareTabOverview: "Ülevaade",
      compareColIssue: "Ülesanne",
      compareColWas: "Oli",
      compareColNow: "Nüüd",
      compareColChange: "Muutus",
      compareBaselineBar: "Kus see salvestatud ajakavas asus",
      compareLegendBaseline: "Baasajakava",
      compareLegendToday: "Täna",
      compareCompletion: "Lõpp",
      compareDaysLater: "{count} päeva hiljem",
      compareDaysEarlier: "{count} päeva varem",
      compareDaysLonger: "{count} päeva pikem",
      compareDaysShorter: "{count} päeva lühem",
      snapshotMeta: "{issues} ülesannet · {deps} sõltuvust",
      snapshotMoved: "{count} liikunud",
      snapshotAdded: "hiljem lisatud",
      snapshotRemoved: "vahepeal kadunud",
      snapshotUnchanged: "Pärast seda ajakava pole midagi liikunud.",
      snapshotCompletionLater: "Lõpp on {days} päeva hilisem kui sellel ajakaval.",
      snapshotCompletionEarlier: "Lõpp on {days} päeva varasem kui sellel ajakaval.",
      snapshotCompletionSame: "Lõpp pole pärast seda ajakava muutunud.",
      emptyTimeline: "Siin pole veel ülesandeid. Lisa üks, et ajakava alustada.",
      truncated: "Kuvatakse {shown} ülesannet {total}-st — kasuta filtreid ülejäänute nägemiseks.",
    },
    tabs: {
      all: "Kõik",
      inProgress: "Töös",
      resolved: "Lahendatud",
      closed: "Suletud",
      overdue: "Tähtaeg möödas",
    },
    filters: {
      discipline: "Distsipliin",
      assignee: "Vastutaja",
      dueDate: "Tähtaeg",
      project: "Projekt",
    },
    filterBy: {
      // "Filtrid" (plural) — same label the Documents toolbar uses.
      title: "Filtrid",
      status: "Staatus",
      overdue: "Tähtaeg möödas",
      overdueOnly: "Ainult tähtaja ületanud",
      overduePinsStatus: "Tähtaja ületanud ülesanded on alati töös.",
      assignee: "Vastutaja",
      discipline: "Distsipliin",
      hasDocuments: "Seotud dokumentidega",
      noDocuments: "Seotud dokumentideta",
      hasComments: "Kommentaaridega",
      noComments: "Kommentaarideta",
      clearAll: "Tühjenda kõik",
      moreFilters: "+{count} veel",
      remove: "Eemalda",
      searchPlaceholder: "Otsi filtreid…",
      hiddenByFilters: "{count} ülesannet peidetud filtritega",
      clearFilters: "Tühjenda filtrid",
    },
    contextMenu: {
      changeDescription: "Muuda kirjeldust",
      status: "Staatus",
      assignees: "Vastutajad",
      discipline: "Distsipliin",
      startDate: "Alguskuupäev",
      noStartDate: "Alguskuupäev puudub",
      dueDate: "Tähtaeg",
      noDueDate: "Tähtaeg puudub",
      makeSubissue: "Märgi alamülesandeks",
      removeFromParent: "Eemalda ülemülesandest",
      createSubissue: "Loo alamülesanne…",
      addDocument: "Lisa dokument",
      moveToProject: "Teisalda projekti",
      noOtherProjects: "Muid projekte pole",
      askFranklin: "Küsi Franklinilt",
      actions: "Tegevused",
      selectedCount: "{count} ülesannet valitud",
    },
    errors: {
      parentHasSubissues:
        "Sellel ülesandel on juba alamülesanded, seega ei saa see ise alamülesandeks muutuda. Lubatud on ainult üks tasand.",
    },
    sortBy: {
      title: "Sorteeri",
      creationDate: "Loomise kuupäev",
      discipline: "Distsipliin",
      status: "Staatus",
      assignee: "Vastutaja",
      dueDate: "Tähtaeg",
    },
    dateBuckets: {
      today: "Täna",
      yesterday: "Eile",
      thisWeek: "Sel nädalal",
      thisMonth: "Sel kuul",
      older: "Vanem",
      noDate: "Kuupäev puudub",
      overdue: "Tähtaeg möödas",
      later: "Hiljem",
    },
    noDiscipline: "Distsipliin puudub",
    noAssignee: "Vastutaja puudub",
    groups: {
      inProgress: "Töös",
      resolved: "Lahendatud",
      closed: "Suletud",
    },
    detail: {
      status: "Staatus",
      assignee: "Vastutaja",
      assignees: "Vastutajad",
      discipline: "Distsipliin",
      startDate: "Alguskuupäev",
      setStartDate: "Määra alguskuupäev",
      dueDate: "Tähtaeg",
      setDueDate: "Määra tähtaeg",
      tags: "Sildid",
      addTag: "Lisa silt",
      editTitle: "Muuda pealkirja",
      assign: "Määra vastutaja",
      elements: "Elemendid",
      created: "Loodud",
      history: "Ülesande ajalugu",
      linkedDocuments: "Seotud dokumendid",
      noLinkedDocuments: "Seotud dokumente pole.",
      addDocument: "Lisa dokument",
      addFromFranklin: "Lisa Franklini logist",
      uploadFiles: "Lae üles",
      uploading: "Laeb üles…",
      processing: "Töötlemisel…",
      processingShort: "Töötlemisel",
      previewUnavailable: "Eelvaade pole saadaval",
      removeDocument: "Eemalda dokument",
      showAllAttachments: "Näita kõiki manuseid ({count})",
      showFewerAttachments: "Näita vähem",
      documents: "Dokumendid",
      attach: "Lisa",
      comments: "Kommentaarid",
      noComments: "Kommentaare veel pole.",
      loadingComments: "Kommentaaride laadimine…",
      addComment: "Lisa kommentaar…",
      send: "Saada",
      commentFailed: "Kommentaari ei õnnestunud postitada. See on tagasi väljas — proovi uuesti.",
      mention: "Maini kedagi",
      justNow: "Just nüüd",
      reply: "Vasta",
      removeQuote: "Eemalda tsitaat",
      edit: "Muuda",
      edited: "Muudetud",
      name: "Nimi",
      issue: "Ülesanne",
      description: "Kirjeldus",
      addSubissue: "Lisa alamülesanne",
      markAsSubissue: "Märgi alamülesandeks",
      pickParent: "Vali ülemülesanne",
      searchIssues: "Otsi ülesandeid…",
      subissueOf: "Alamülesanne ülesandele #{n} — {title}",
      documentThreadsTitle: "{filename} kommentaarid",
      removeFromParent: "Eemalda ülemülesandest",
      makeTopLevel: "Muuda iseseisvaks ülesandeks",
      linkedToIssue: "Lisatud ülesandele #{n} — {title}",
      linkedToIssues: "Lisatud {count} ülesandele",
      systemFolderLocked: "Faile lisatakse siia ülesannete lehelt.",
    },
    status: {
      in_progress: "Töös",
      resolved: "Lahendatud",
      closed: "Suletud",
    },
    checklist: {
      title: "Kontrollnimekiri",
      addChecklist: "Lisa kontrollnimekiri",
      removeChecklist: "Eemalda kontrollnimekiri",
      addToIssue: "Lisa ülesandele",
      addPlaceholder: "Lisa punkt",
      deleteItem: "Kustuta punkt",
      reorderItem: "Lohista järjekorra muutmiseks",
      progress: "{done}/{total}",
      progressLabel: "Kontrollnimekiri: {done}/{total} tehtud",
      tooLong: "Kontrollnimekirja punkt võib olla kuni 500 tähemärki.",
      stale: "Kontrollnimekiri muutus järjestamise ajal ja laaditi uuesti.",
      loadFailed: "Kontrollnimekirja laadimine ebaõnnestus.",
    },
    dependencies: {
      title: "Sõltuvused",
      add: "Lisa",
      addDependency: "Lisa sõltuvus",
      addWaitingOnHint:
        "Vali ülesanne, mis peab toimuma enne. Mõlemad peavad olema samas projektis.",
      addDrivesHint: "Vali ülesanne, mis järgneb sellele. Mõlemad peavad olema samas projektis.",
      waitingOn: "Ootab",
      drives: "Mõjutab",
      offPage: "Pole laaditud",
      linkedIssue: "seotud ülesanne",
      abbrFS: "LA",
      abbrSS: "AA",
      abbrFF: "LL",
      abbrSF: "AL",
      pickRelationship: "Vali seos, et sõltuvus salvestada.",
      cancelDraft: "Loobu",
      typeFS: "Lõpp → algus",
      typeSS: "Algus → algus",
      typeFF: "Lõpp → lõpp",
      typeSF: "Algus → lõpp",
      lag: "Nihe päevades",
      lagHint: "Päevi pärast tingimust. Negatiivne väärtus paneb need osaliselt kattuma.",
      rigid: "Range",
      flexible: "Paindlik",
      rigidHint: "Range: see ülesanne liigub koos eelnevaga.",
      flexibleHint: "Paindlik: ainult planeeritud järjekord. Midagi ei liigu ise, saad hoiatuse.",
      pinnedHint:
        "Need kuupäevad on käsitsi määratud, seega jäävad nad eelneva liikumisel paigale.",
      unpin: "Järgi eelnevaid",
      remove: "Eemalda sõltuvus",
      empty:
        "Selle ülesande ümber pole veel midagi ajastatud. Sõltuvus paneb ühe ülesande liikuma koos teisega.",
      addWaitingOn: "See ülesanne ootab…",
      addDrives: "See ülesanne juhib…",
      searchIssues: "Otsi ülesandeid…",
      noIssuesFound: "Ülesandeid ei leitud",
      relationship: "Seos",
      movesTogether: "Liigub koos",
      days: "päeva",
      infoLabel: "Teave: {label}",
      relationshipInfo: "Milline eelneva ülesande kuupäev määrab järgneva kuupäeva.",
      typeFSInfo: "Järgnev algab, kui eelnev lõpeb. Tavaline valik.",
      typeSSInfo: "Järgnev algab, kui eelnev algab.",
      typeFFInfo: "Järgnev lõpeb, kui eelnev lõpeb.",
      typeSFInfo: "Järgnev lõpeb, kui eelnev algab. Vajalik harva.",
      lagInfo:
        "Päevade vahe kahe kuupäeva vahel. +2 ootab kaks päeva, −2 laseb neil kaks päeva kattuda.",
      movesTogetherInfo: "Mis juhtub järgneva ülesandega, kui eelnev liigub.",
      rigidInfo: "Kuupäevad nihkuvad automaatselt sama palju.",
      flexibleInfo: "Midagi ei liigu ise; saad hoiatuse, kui järjekord rikutakse.",
      waitingOnInfo: "Ülesanded, mis peavad toimuma enne seda.",
      drivesInfo: "Ülesanded, mis liiguvad koos selle ülesandega.",
      summaryFS: "{later} algab, kui {earlier} lõpeb",
      summarySS: "{later} algab, kui {earlier} algab",
      summaryFF: "{later} lõpeb, kui {earlier} lõpeb",
      summarySF: "{later} lõpeb, kui {earlier} algab",
      thisIssue: "see ülesanne",
      summaryRigid: "liigub koos",
      summaryFlexible: "ei liigu ise",
      unscheduled: "Ajastamata",
      violated: "Algab liiga vara",
      violatedDetail: "See seos lubab kõige varem {date}.",
      staged: "Salvestamata",
      waitingCount: "{count} ootel",
      drivesCount: "{count} juhitud",
      none: "Puuduvad",
      lagLater: { one: "{count} päev hiljem", other: "{count} päeva hiljem" },
      lagEarlier: { one: "{count} päev varem", other: "{count} päeva varem" },
      lagNone: "viiteta",
    },
    schedule: {
      affectsOne: "See muudatus mõjutab 1 sõltuvat tegevust.",
      affectsMany: "See muudatus mõjutab {count} sõltuvat tegevust.",
      batchAffectsOne: "Sinu muudatused liigutavad 1 teist tegevust.",
      batchAffectsMany: "Sinu muudatused liigutavad {count} teist tegevust.",
      nothingMoves: "Midagi muud liigutada ei ole vaja.",
      completionLater: "Projekti lõpp nihkub {days} päeva hilisemaks.",
      completionEarlier: "Projekti lõpp nihkub {days} päeva varasemaks.",
      completionUnchanged: "Projekti lõpp ei muutu.",
      movingLabel: "Liiguvad",
      notMovingLabel: "Jäävad paigale",
      pinnedWarning: "#{n} {title} on kinnitatud, seega jäävad valitud kuupäevad kehtima.",
      softWarning: "#{n} {title} on planeeritud algama {date}, kuid algab nüüd varem.",
      bulkSummary: "{moved} sõltuvat ülesannet liikus, {held} jäi paigale.",
      updateSchedule: "Uuenda ajakava",
      keepCurrentDates: "Jäta kuupäevad samaks",
      applied: "Ajakava uuendatud — {count} ülesannet liikus",
      appliedOne: "Ajakava uuendatud — 1 ülesanne liikus",
      undo: "Võta tagasi",
      undone: "Ajakava taastatud",
      undoFailed: "Ajakava ei õnnestunud taastada.",
    },
    statuses: {
      newStatus: "Uus staatus",
      newTitle: "Uus staatus",
      editTitle: "Muuda staatust",
      description: "Staatus kuulub ühte projekti. Seda näevad kõik, kes selles projektis töötavad.",
      nameLabel: "Nimi",
      namePlaceholder: "Blokeeritud",
      colourLabel: "Värv",
      previewLabel: "Eelvaade",
      createAction: "Loo staatus",
      deleteTitle: "Kustutada see staatus?",
      deleteChecking: "Kontrollime, kas mõni ülesanne seda veel kasutab…",
      deleteInUse:
        "{count} ülesannet kasutab seda staatust. Määra neile enne mõni teine staatus — kustutamine muudaks need kasutuskõlbmatuks.",
      deleteConfirm:
        "Ükski ülesanne seda ei kasuta, nii et selle saab eemaldada. Seda ei saa tagasi võtta.",
      notInThisProject:
        "See staatus kuulub teise projekti, seega ei saa seda ülesannet sellele määrata.",
      orderNotSaved:
        "Kaart liikus, kuid uut järjekorda ei salvestatud — selles veerus on ülesandeid projektist, mida sa hallata ei saa.",
      reorderColumn: "Liiguta seda veergu",
      needsProject: "Staatuse lisamiseks vali üks projekt — staatus kuulub ühte projekti.",
    },
    empty: "Ülesandeid ei leitud",
    emptyOverdue: {
      title: "Tähtaja ületanud ülesandeid pole",
      subtitle: "Siia ilmuvad töös olevad ülesanded, mille tähtaeg on möödas.",
    },
    addIssue: "Lisa ülesanne",
    search: "Otsi ülesandeid…",
    allProjects: "Kõik projektid",
    assigneesPlaceholder: "Vali vastutajad…",
    searchUsers: "Otsi kasutajaid…",
    noUsersFound: "Kasutajaid ei leitud.",
    myDisciplines: "Minu vastutusalad",
    myDisciplinesTooltip: "Sinu vastutusalad selles projektis, määratud Kontaktide lehel",
    suggestedAssignees: "Vastutavad nende erialade eest",
    otherAssignees: "Kõik teised",
    draft: {
      newIssue: "Uus ülesanne",
      marker: "Uus",
      untitled: "Kirjeldus puudub",
      saving: "Salvestamine…",
      create: "Loo",
      creating: "Loomine…",
      createNeedsDescription: "Ülesande loomiseks lisa kirjeldus",
      noProject: "Pole projekti, kuhu see ülesanne lisada",
      saveFailed:
        "Ülesannet ei õnnestunud salvestada. See on endiselt avatud, et saaksid uuesti proovida.",
      saveFailedWaiting:
        "Ülesannet ei õnnestunud salvestada. See jääb ülesannete lehele, et saaksid uuesti proovida.",
      reopen: "Ava",
      discardFailed:
        "Ülesandest ei õnnestunud loobuda. See jääb ülesannete lehele, et saaksid uuesti proovida.",
      uploadInProgress: "Oota kõigepealt, kuni üleslaadimine lõpeb",
      needsDescriptionTitle: "Ülesande salvestamiseks lisa kirjeldus",
      needsDescriptionBody:
        "Ülesanne salvestatakse selle kirjelduse alla. Lisa kirjeldus, et sisestatu alles jääks, või loobu ülesandest.",
      addDescription: "Lisa kirjeldus",
      discard: "Loobu ülesandest",
    },
    bulkActions: {
      issueSelected: "ülesanne valitud",
      issuesSelected: "ülesannet valitud",
      status: "Olek",
      discipline: "Eriala",
      assignees: "Vastutajad",
      dueDate: "Tähtaeg",
      askFranklin: "Küsi Franklinilt",
      delete: "Kustuta",
      apply: "Rakenda",
      confirmDeleteTitle: "Kustutada ülesanded?",
      confirmDeleteDescription: "Kas oled kindel, et soovid kustutada {count} ülesannet?",
    },
  },
  activity: {
    historyTitle: "Ülesande ajalugu",
    historyEmpty: "Ajalugu veel pole.",
    system: "Süsteem",
    created: "{actor} lõi selle ülesande",
    deleted: "{actor} kustutas selle ülesande",
    restored: "{actor} taastas selle ülesande",
    titleChanged: "{actor} muutis pealkirjaks „{new}”",
    statusChanged: "{actor} muutis staatuse: {old} → {new}",
    startDateSet: "{actor} määras alguskuupäevaks {new}",
    startDateChanged: "{actor} muutis alguskuupäeva {old} -> {new}",
    startDateCleared: "{actor} eemaldas alguskuupäeva",
    dueDateSet: "{actor} määras tähtajaks {new}",
    dueDateChanged: "{actor} muutis tähtaja: {old} → {new}",
    dueDateCleared: "{actor} eemaldas tähtaja",
    parentSet: "{actor} määras ülemülesandeks #{n}",
    parentRemoved: "{actor} eemaldas ülemülesande",
    assigneeAdded: "{actor} määras vastutajaks {name}",
    assigneeRemoved: "{actor} eemaldas vastutaja {name}",
    disciplineAdded: "{actor} lisas distsipliini {name}",
    disciplineRemoved: "{actor} eemaldas distsipliini {name}",
    documentAttached: "{actor} lisas faili {file}",
    documentDetached: "{actor} eemaldas faili {file}",
    elementLinked: "{actor} sidus elemendi {element}",
    viewpointSaved: "{actor} salvestas 3D vaate",
    viewpointCleared: "{actor} eemaldas salvestatud 3D vaate",
    dependencyAdded: "{actor} seadis selle sõltuma ülesandest #{n}",
    dependencyRemoved: "{actor} eemaldas sõltuvuse ülesandest #{n}",
    schedulePinned: "{actor} kinnitas need kuupäevad",
    scheduleUnpinned: "{actor} lubas need kuupäevad eelnevate järgi liikuda",
    drawingAnchorSaved: "{actor} salvestas asukoha joonisel",
    drawingAnchorCleared: "{actor} eemaldas asukoha jooniselt",
    elementUnlinked: "{actor} eemaldas elemendi {element}",
    commentAdded: "{actor} kommenteeris",
    checklistItemAdded: "{actor} lisas kontrollnimekirja punkti „{item}”",
    checklistItemRemoved: "{actor} eemaldas kontrollnimekirja punkti „{item}”",
    checklistItemRenamed: "{actor} nimetas punkti „{old}” ümber: „{new}”",
    checklistItemChecked: "{actor} märkis tehtuks: „{item}”",
    checklistItemUnchecked: "{actor} märkis tegemata: „{item}”",
    commentEdited: "{actor} muutis kommentaari",
  },
  notifications: {
    title: "Teavitused",
    subtitle: "Kõik, mis on toimunud sulle ligipääsetavates ülesannetes",
    empty: {
      title: "Hetkel pole midagi näidata",
      subtitle: "Siia ilmuvad muudatused ülesannetes, millele sul on ligipääs.",
    },
    filter: {
      // Plural, matching the Documents and Issues toolbars.
      title: "Filtrid",
      type: "Tegevuse tüüp",
      person: "Isik",
      unread: "Lugemata",
      unreadOnly: "Ainult lugemata",
      timeRange: "Ajavahemik",
      clearAll: "Tühjenda kõik",
      categories: {
        created: "Loodud / kustutatud",
        title: "Pealkiri",
        status: "Staatus",
        dueDate: "Kuupäevad",
        assignees: "Vastutajad",
        disciplines: "Distsipliinid",
        files: "Failid",
        elements: "BIM-elemendid",
        comments: "Kommentaarid",
        parent: "Ülemülesanne",
        checklist: "Kontrollnimekiri",
        dependencies: "Sõltuvused",
      },
      ranges: {
        all: "Kogu aeg",
        today: "Täna",
        last7: "Viimased 7 päeva",
        last30: "Viimased 30 päeva",
        custom: "Kohandatud vahemik",
      },
      customRangeHint: "Vali algus- ja lõpupäev – ühe päeva jaoks sama päev kaks korda",
      apply: "Rakenda",
    },
  },
  common: {
    filter: "Filter",
    search: "Otsi",
    cancel: "Tühista",
    save: "Salvesta",
    delete: "Kustuta",
    confirmDelete: "Kas olete kindel, et soovite selle kustutada?",
  },
};
